import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

export const AppsRedirect = ({ to }) => {
  const shouldRedirectUsingServer = to.startsWith('/app');

  useEffect(() => {
    if (shouldRedirectUsingServer) {
      window.location.replace(to);
    }
  }, [shouldRedirectUsingServer, to]);

  if (!shouldRedirectUsingServer) {
    return <Redirect to={to} />;
  } else {
    return null;
  }
};
